// extracted by mini-css-extract-plugin
module.exports = {"navSoft":"TableHeader_navSoft__1OIO-","myButton":"TableHeader_myButton__2b8q5"};